import { useDispatch } from "react-redux";
import { createSetBatteryAction } from "state/reducer";
import { useDedupEffect } from "./useDedupEffect";
import { Battery } from "../Types/AppStateTypes";
const logPrefix = "[ADPClient][BatteryServiceHook]"
export function useBatteryService() {
    const dispatch = useDispatch()
  async function getBatteryLevel() {
    // @ts-ignore
    const batteryObject = await navigator.getBattery();
    const batteryLevel:Battery = {level:batteryObject.level, charging:batteryObject.charging}
    dispatch(createSetBatteryAction(batteryLevel));
    // @ts-ignore
    navigator.getBattery().then((battery) => {
      battery.onchargingchange = () => {
          console.log(logPrefix,`battery is charging: ${battery.charging}]`);
          const batteryLevel:Battery = {level:battery.level, charging:battery.charging}
         dispatch(createSetBatteryAction(batteryLevel));
       };
      battery.onlevelchange = () => {
          console.log(logPrefix,`battery level: ${battery.level * 100}]`);
          const batteryLevel:Battery = {level:battery.level, charging:battery.charging}
          dispatch(createSetBatteryAction(batteryLevel));
      };
  });
}
useDedupEffect(() => {
    getBatteryLevel();
  }, []);
}


